module.exports = __webpack_public_path__ + "img/android_os.552727d8.svg";